import { Box, Stack } from "@chakra-ui/react";
import { getCdnImageSrc, Image, VStack, responsive, colors } from "goi_common";
import { ReactNode } from "react";

export default function FlowerBenefitSection() {
  return (
    <VStack width="100%" alignItems="center" background={colors.gray900}>
      <VStack
        maxWidth={`${1200}px`}
        gap="28px"
        css={responsive({
          padding: {
            base: "64px 24px",
            lg: "120px 24px",
          },
        })}
      >
        <VStack
          width="100%"
          css={responsive({
            alignItems: { base: "center", lg: "flex-start" },
            marginBottom: "40px",
          })}
          gap="16px"
        >
          <Box
            className="white head_28_b lg_head_42_b"
            css={responsive({ textAlign: { base: "center", lg: "left" } })}
          >
            이제는 근조 발송으로 고생하지 마세요
          </Box>
          <Box
            className="gray300 subtitle_16_m lg_head_24_r"
            css={responsive({ textAlign: { base: "center", lg: "left" } })}
          >
            화환 주문이 밀려서 안 된다고요?
            <br />
            장례식장 근처 화환을 직접 검색해서 진행하신다고요?
          </Box>
        </VStack>
        <BenefitItem
          num={1}
          title={"전국 배송 3시간만에 도착"}
          description={<>전국 어디든 발주 후 3시간만에 도착합니다.</>}
          imageSize={{
            width: { base: "80%", lg: "26%" },
            height: { base: "100%", lg: "230px" },
            paddingLeft: { base: "30px", lg: "0" },
          }}
        />
        <BenefitItem
          num={2}
          title={"카톡 한 번으로 발주 끝"}
          description={
            <>
              카톡이나 전화로 발주하면, 배송현황을 카톡으로 보내드려요
              <br />
              도착유무 확인을 위해 매번 전화할 필요 없어요.
            </>
          }
          imageSize={{
            width: { base: "100%", lg: "40%" },
            height: { base: "100%", lg: "300px" },
          }}
        />
        <BenefitItem
          num={3}
          title={"전국 최저가, 근조화환 발송 7만원부터"}
          description={
            <>
              생산/유통망을 효율화했습니다.
              <br />
              전국 최저가로 근조화환 발송이 가능해요
            </>
          }
          imageSize={{
            width: { base: "85%", lg: "30%" },
            height: { base: "100%", lg: "300px" },
            paddingLeft: { base: "50px", lg: "0" },
          }}
        />
      </VStack>
    </VStack>
  );
}

function BenefitItem({
  num,
  title,
  imageSize,
  description,
}: {
  num: number;
  title: string;
  imageSize: {
    width: { base: string; lg: string };
    height: { base: string; lg: string };
    paddingLeft?: { base: string; lg: string };
  };
  description: ReactNode;
}) {
  return (
    <Stack
      gap="16px"
      justifyContent="space-between"
      css={responsive({
        flexDirection: { base: "column", lg: "row" },
        padding: { base: "24px", lg: "52px 48px" },
        borderRadius: "16px",
      })}
      background={colors.gray100}
      overflow="hidden"
    >
      <VStack
        justifyContent="center"
        css={responsive({
          width: { base: "100%", lg: "50%" },
        })}
      >
        <Box className="orange650 subtitle_18_b lg_head_24_b">0{num}</Box>
        <Box
          className="gray900 head_24_b lg_head_32_b"
          css={responsive({
            whiteSpace: "pre-line",
            padding: { base: "8px 0 10px", lg: "16px 0 20px" },
          })}
        >
          {title}
        </Box>

        <Box
          className="gray600 body_14_r lg_subtitle_21_r"
          css={{ wordBreak: "keep-all" }}
        >
          {description}
        </Box>
      </VStack>
      <VStack
        borderRadius="16px"
        css={responsive(imageSize)}
        justifyContent="center"
      >
        <Image
          src={getCdnImageSrc(`b2b/flower/benefit-1-${num}.png`)}
          width="100%"
          height="auto"
          alt=""
        />
      </VStack>
    </Stack>
  );
}
